import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "typeahead typeahead-wrapper" }
const _hoisted_3 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexTypeahead',
  setup(__props) {

const BasicTypeahead = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/typeahead/BasicTypeahead.vue"))
const PrefetchTypeahead = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/typeahead/PrefetchTypeahead.vue"))
const BloodhoundTyeahead = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/typeahead/BloodhoundTyeahead.vue"))
const RemoteTypeahead = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/typeahead/RemoteTypeahead.vue"))
const CustomTemplates = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/typeahead/CustomTemplates.vue"))
const MultipleSections = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/typeahead/MultipleSections.vue"))
const ScrollableMenu = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/typeahead/ScrollableMenu.vue"))
const RtlSupport = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/typeahead/RtlSupport.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", {
      class: "alert txt-primary bg-light-primary alert-dismissible fade show",
      role: "alert"
    }, [
      _createElementVNode("i", { "data-feather": "alert-triangle" }),
      _createElementVNode("p", null, [
        _createTextVNode("This is the Typeahead page where "),
        _createElementVNode("strong", null, "jQuery "),
        _createTextVNode(" was utilised.")
      ]),
      _createElementVNode("button", {
        class: "btn-close",
        type: "button",
        "data-bs-dismiss": "alert",
        "aria-label": "Close"
      })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(BasicTypeahead)),
        _createVNode(_unref(PrefetchTypeahead)),
        _createVNode(_unref(BloodhoundTyeahead)),
        _createVNode(_unref(RemoteTypeahead)),
        _createVNode(_unref(CustomTemplates)),
        _createVNode(_unref(MultipleSections)),
        _createVNode(_unref(ScrollableMenu)),
        _createVNode(_unref(RtlSupport))
      ])
    ])
  ]))
}
}

})